import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { PageRef } from '../../core/core.module';
import { StoreLocatorPage} from './pages/store-locator/store-locator';
import { StoreLocatorPageFull } from './pages/store-locator/store-locator.full';
import { StoreInfoPage} from './pages/store-info/store-info';
import { StoreInfoPageFull} from './pages/store-info/store-info.full';
import { AgmCoreModule } from 'angular2-google-maps/core';
import { StoreLocatorCommon } from './pages/store-locator/store-locator.common';
import { StoreLocatorData }from'./providers/store-locator-data';
import { HaversineService } from "ng2-haversine";
//
export { StoreLocatorPage} from './pages/store-locator/store-locator';
export { StoreLocatorPageFull } from './pages/store-locator/store-locator.full';
export { StoreInfoPage} from './pages/store-info/store-info';
export { StoreInfoPageFull} from './pages/store-info/store-info.full';

@NgModule({
	imports: [
		IonicModule,
		AgmCoreModule .forRoot({
			apiKey : 'AIzaSyBkAqJwy0yJMFYmVIPZm0WZIJ5LUavmcr4'
		})
	],
	declarations: [
        StoreLocatorPage,
        StoreLocatorPageFull,
        StoreInfoPage,
        StoreInfoPageFull,
    ],
    exports: [
        StoreLocatorPage,
        StoreLocatorPageFull,
        StoreInfoPage,
        StoreInfoPageFull,
    ],
    bootstrap: [],
    entryComponents: [
        StoreLocatorPage,
        StoreLocatorPageFull,
        StoreInfoPage,
        StoreInfoPageFull,
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler},StoreLocatorData, StoreLocatorCommon,HaversineService]
})
export class StoreLocatorModule{
	constructor(public pageRef: PageRef){
       this.pageRef.addCfgLinks([
            { component: StoreLocatorPage, fullComponent: StoreLocatorPageFull, name: 'Store Locator', segment: 'store-locator' },
            { component: StoreInfoPage, fullComponent: StoreInfoPageFull, name: 'Store Info', segment: 'store-info' }
			
        ]) 
    }

}


// WEBPACK FOOTER //
// ./src/modules/store-locator/store-locator.module.ts